/***
 * 地点单行
 */

import React from 'react';
import { getData } from '@util';
import { Select } from 'antd';
import { API_POST_BBC_SUPPLIER_GETSHIPPER } from '@api';
class LocationOnlyInLine extends React.PureComponent {
  state = {
    AddCodeData: [],
  };

  componentDidMount() {
    this.getAddCodeFunc();
  }

  // 获取地点
  getAddCodeFunc = () => {
    getData({
      api: API_POST_BBC_SUPPLIER_GETSHIPPER,
      data: {
        pageNo: 1,
        pageSize: 500,
      },
    }).then(res => {
      const { data } = res;
      this.setState({
        AddCodeData: data.data,
      });
    });
  };

  render() {
    const { AddCodeData = [] } = this.state;
    const { isSingleSelect, renderValue } = this.props;
    return (
      <Select
        mode={!isSingleSelect && 'multiple'}
        tokenSeparators={[' ']}
        optionFilterProp="children"
        allowClear
        showSearch
        placeholder={'请选择'}
        {...this.props}
        onChange={x => {
          if (!isSingleSelect) {
            const y = Array.from(new Set(x));
            this.props.onChange && this.props.onChange(y);
          } else {
            this.props.onChange && this.props.onChange(x);
          }
        }}>
        {AddCodeData.map(item => (
          <Select.Option
            title={`${item.code}-${item.name}`}
            key={item.code}
            value={
              renderValue ? renderValue(item) : `${item.code}-${item.name}`
            }>{`${item.code}${item.name}`}</Select.Option>
        ))}
      </Select>
    );
  }
}

export default LocationOnlyInLine;
